module.exports = __webpack_public_path__ + "img/9.SonyTV1080p.fa74258f.png";